global.Intl = require('intl');
